export const COMPANY_NAME = "Dixon Lin LLC";
export const COMPANY_SHORT = "Dixon Lin";
export const COMPANY_INITIALS = "DL";
export const COMPANY_ADDRESS_FULL = "8605 Santa Monica Blvd #279576, West Hollywood, CA 90069";
export const COMPANY_LOCATION = "West Hollywood, CA";
export const COMPANY_REGION = "Los Angeles County, California";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=8605%20Santa%20Monica%20Blvd%20%23279576%2C%20West%20Hollywood%2C%20CA%2090069";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Organization", "value": "California LLC" },
  { "label": "Established", "value": "2025" },
  { "label": "Location", "value": "West Hollywood, CA" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Dixon Lin LLC" },
  { "label": "Location", "value": "West Hollywood, CA" },
  { "label": "Principal office", "value": "8605 Santa Monica Blvd #279576, West Hollywood, CA 90069" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Apparel Design", "body": "A public business profile for an organization associated with clothing design." },
  { "icon": "✦", "title": "Creative Development", "body": "Publicly available information describes an interest in creating apparel." },
  { "icon": "✿", "title": "California LLC", "body": "Organized in California as a limited liability company in 2025." },
  { "icon": "❍", "title": "West Hollywood", "body": "Principal office information is available for this Los Angeles County organization." },
];
